module.exports = __webpack_public_path__ + "media/images/svg/house-d3d7602f5cb13dd1785bc373a4461a5d.svg";